import React from "react";
 
export const TableStatusField = ({ className, status }) => {
  const message = {
    NON_INVITED: "Non Invited",
    INVITED: "Invited",
    IN_REGISTRATION: "In Registration",
    REGISTERD: "Registered",
    REJECT: "Reject",
    DEACTIVATED: "Deactivated",
    ACTIVATED: "Activated",
    IN_RELEASE: "In Release",
    CANCELLED: "Cancelled",
    PR_APPOVED: "PR Approved",
    ACKNOWLEDGED: "Acknowledged",
    PUBLISHED: "Published",
    QTN_RECEIVED: "QTN Received",
    RFQ_CREATED: "RFQ Created",
    COMERCIAL_APPROVED: "Commercial Approved",
    TECH_APPROVED: "Tech Approved",
    TECHNICAL_OPEN: "Technical Open",
    COMERCIAL_OPEN: "Commercial Open",
    SUBMITTED: "Submitted",
    NEW: "New",
    IN_TRANSIT: "In Transit",
    GATEPASS_CREATED: "Gatepass Created",
    GRN_CREATED: "GRN Created",
    PENDING_FOR_APPROVAL: "Pending for Approval",
    INVOICE_CANCELLED: "Invoice Cancelled",
    GRN_REJECTED: "GRN Rejected",
    POSTED: "Posted",
    GRN_APPROVED: "GRN Approved",
    ENTRY_SHEET_CREATED: "Entrysheet Created",
    SES_REJECTED: "SES Rejected",
    INVOICE_CREATED: "Invoice Created",
    SES_CANCELLED: "SES Cancelled",
    INVOICE_APPROVED: "Invoice Approved",
    ON_BOARDED: "On Boarded",
    PENDING: "Pending",
    ASN_CANCELLED: "ASN Cancelled",
    GRN_CSNCELLED: "GRN Cancelled",
    APPROVE: "Approve",
    SES_CREATED: "SES Created",
    OPEN: "OPEN",
    CLOSE: "CLOSE",
    PERTIALLY_DISP: "Partially Dispatched",
    FULLY_DISP: "Fully Dispatched",
    APPROVED: "Approved",
    PENDING_WITH_L1: "Pending with L1",
    PENDING_WITH_L2: "Pending with L2",
    COMM_PENDING_WITH_L1: "Commercial Pending with L1",
    COMM_PENDING_WITH_L2: "Commercial Pending with L2",
    KYC_UPDATED: "KYC Updated",
    KYC_PENDING: "KYC Pending",
    Confirmed: "Confirmed",
    InTransit: "InTransit",
    KYC_Approved: "KYC Approved",
    KYC_PendingwithL1: "KYC Pending with L1",
    KYC_PendingwithL2: "KYC Pending with L2",
    Cash_IN_Transit: "Cash in Transit",
    Partial_Amount: "Partial Amount",
    Full_Amount: "Full Amount",
    Not_Received: "Not Received",
    InWard: "InWard",
    OutWard: "OutWard",
    Publish: "Publish",
    Regret: "Regret",
    PO_Created: "PO Created",
    ACTIVE:"Active",
    INACTIVE:"Inactive",
    Partially_Received:"Partially Received",
    Fully_Received:"Fully Received",
    Quality_Check:"QC Pending",
    PO_REVISED:"PO Revised",
    PO_REJECTED:"Rejected",
    PO_APPROVED:"PO Approved",
 
    Vendor:"Vendor",
    newPatient:"New Patient",
    oldPatient:"Old Patient",
    Hospital:"Hospital",
    Consultant:"Consultant",
    ServiceProvider:"Service Provider",
    Distributor:"Distributor",
    Manufacturer:"Manufacturer",
    BusinessLogistics:"Business Logistics",
    Doctor:"Doctor",
    Patient:"Patient",
    Nursing:"Nursing",
    Service_Person:"Service Person",
    Supplier: "Supplier",
    Created: "Created",
    Open: "Open",
    Initial:"Initial",
    Extended:"Extended",
    salePoint:"MediRent",
    Extension:"Extension",
    Partial_Ext:"Partial Ext",
    inProgress:"In progress",
    Sale_Rent:"Sale & Rent",
    ErfType_Rent:"Rent",
    ErfType_Sale:"Sale",
    ErfType_Nursing_Service:"Nursing Service",
    ErfType_Service:"Service",
    Erf_Status:"Ready To Dispatch",
    Erf_assignStatus:"Assign To Store",
    Dispatched_Erf:"Dispatched",
    ERF_Rent_Credit_Note:"Rent Credit Noted",
    ERF_Nursing_Credit_Note:"Nursing Credit Noted",
    Extension_Erf_Pay_Pending:"Pending Payment",
    Extension_Erf_Under_SE:"RE Under Service Executive",
    Extension_Erf_Pay_Collected:"RE Payment Collected",
    Erf_Expired: "Expired",
    Erf_ExpiresToday: "Expires Today",
    Erf_1_day_left: "1 day left",
    Erf_2_days_left: "2 days left",
    Erf_3_days_left: "3 days left",
    Erf_Valid: "Valid",
    pcCallClosed:"Closed",
    pcCallPartial:"Partial Ext",
    pcCallIntransist:"Follow Up",
    pcCallFollowUp:"In Transit",
    PartialEarlyClosure:"Partial Early Closure",
    EarlyClosure:"Early Closure",
    AssignServiceProvider:"Assign Service Provider",
    Erf_UnderServiceExecutive:"Under Service Executive",
    ServiceCancelled:"Service Cancelled",
    ServiceCompleted:"Service Completed",
    ServiceInProgress:"Service In Progress",
    ServicePending:"Service Pending",
    Returning_Material_To_Store:"Returning Material To Store",
    Returning_To_Store:"Returning To Store",
    RFQ_Submitted:"RFQ Submitted",
    Reverse_Auction:"Reverse",
    Forward_Auction:"Forward",
    Ended:"Ended",
    ended:"Ended",
    Pending_Artwork: "Pending Artwork",
    Pending_Artwork_Approval: "Pending Artwork Approval",
    Under_Review: "Under Review",
    Approved_Ready_For_QAP: "Approved - Ready for QAP",
    In_QAP: "In QAP",
    Artwork_Rejected: "Artwork Rejected",


  }
 
  return (
    <>
      {status === message.NON_INVITED ? (
        <span className="bg-table-status bg-table-info-status">{status}</span>
      ) : status === message.INVITED ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.IN_REGISTRATION ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.REGISTERD ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.REJECT ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.DEACTIVATED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.ACTIVATED ? (
        <span className="bg-table-status bg-table-success-status">{status}</span>
      ) : status === message.IN_RELEASE ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.CANCELLED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.PR_APPOVED ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.ACKNOWLEDGED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.PUBLISHED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.QTN_RECEIVED ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.CANCELLED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.RFQ_CREATED ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.COMERCIAL_APPROVED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.TECH_APPROVED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.TECHNICAL_OPEN ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.COMERCIAL_OPEN ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.SUBMITTED ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.NEW ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.IN_TRANSIT ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.GATEPASS_CREATED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.GRN_CREATED ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.PENDING_FOR_APPROVAL ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.PENDING_FOR_APPROVAL ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.INVOICE_CANCELLED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.GRN_REJECTED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.POSTED ? (
        <span className="bg-table-status bg-table-info-status">{status}</span>
      ) : status === message.GRN_APPROVED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.GRN_APPROVED ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.ENTRY_SHEET_CREATED ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.SES_REJECTED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.INVOICE_CREATED ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.SES_CANCELLED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.INVOICE_APPROVED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.ON_BOARDED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.PENDING ? (
        <span className="bg-table-status bg-table-info-status">{status}</span>
      ) : status === message.ASN_CANCELLED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.GRN_CSNCELLED ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.APPROVE ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.SES_CREATED ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.OPEN ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.PERTIALLY_DISP ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.FULLY_DISP ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.CLOSE ? (
        <span className="bg-table-status bg-table-danger-status">
          {status}
        </span>
      ) : status === message.APPROVED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.PENDING_WITH_L1 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.PENDING_WITH_L2 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.COMM_PENDING_WITH_L1 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.COMM_PENDING_WITH_L2 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.KYC_UPDATED ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.KYC_PENDING ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.Confirmed ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.KYC_Approved ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.KYC_PendingwithL1 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.KYC_PendingwithL2 ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.InTransit ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.Cash_IN_Transit ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.Partial_Amount ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.Full_Amount ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.Not_Received ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.InWard ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ) : status === message.OutWard ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.Publish ? (
        <span className="bg-table-status bg-table-new-status">{status}</span>
      ) : status === message.Regret ? (
        <span className="bg-table-status bg-table-danger-status">{status}</span>
      ) : status === message.PO_Created ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ): status === message.ACTIVE ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ): status === message.INACTIVE ? (
        <span className="bg-table-status bg-table-danger-status">
          {status}
        </span>
      ) : status === message.Fully_Received ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ): status === message.Partially_Received ? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      ): status === message.Quality_Check ? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      ): status === message.PO_REVISED ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ): status === message.PO_REJECTED ? (
        <span className="bg-table-status bg-table-danger-status">
          {status}
        </span>
      ) : status === message.PO_APPROVED ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.Vendor ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) : status === message.newPatient ? (
        <span className="bg-table-status bg-table-danger-status">
          {status}
        </span>
      ) : status === message.oldPatient ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ) : status === message.Hospital ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      )  : status === message.Consultant ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      )  : status === message.ServiceProvider ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      )  : status === message.Distributor ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      )  : status === message.Manufacturer ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      )  : status === message.BusinessLogistics ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      )  : status === message.Doctor ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      )   : status === message.Supplier ? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      ) : status === message.Created ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ):  status === message.Patient ? (
        <span className="bg-table-status bg-table-info-status">
          {status}
        </span>
      ) :  status === message.Nursing ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) :  status === message.Service_Person ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      )
      : status === message.Open ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ):status === message.Initial ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ): status === message.Extended ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ): status === message.salePoint ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ): status === message.Extension ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ): status === message.Partial_Ext ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ): status === message.inProgress ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ): status === message.Sale_Rent ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ): status === message.ErfType_Rent ? (
        <span className="ps-4 pe-4 bg-table-status bg-table-danger-status">
          {status}
        </span>
      ): status === message.ErfType_Sale ? (
        <span className="ps-4 pe-4 bg-table-status bg-table-new-status">
          {status}
        </span>
      ): status === message.ErfType_Nursing_Service ? (
        <span className="ps-2 pe-2 bg-table-status bg-table-warning-status">
          {status}
        </span>
      ) : status === message.ErfType_Service ? (
        <span className="ps-4 pe-4 bg-table-status bg-table-info-status">
          {status}
        </span>
      ): status === message.Erf_Status ? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      ): status === message.Erf_assignStatus ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ): status === message.Dispatched_Erf ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ) :status === message.ERF_Rent_Credit_Note ? (
        <span className="inline-flex items-center rounded-full bg-yellow-400 px-3 py-1 text-xs font-semibold text-black">
          {status}
        </span>
      ) : status === message.ERF_Nursing_Credit_Note ? (
        <span className="inline-flex items-center rounded-full bg-yellow-400 px-3 py-1 text-xs font-semibold text-black">
          {status}
        </span>
      )
      : status === message.Extension_Erf_Pay_Pending ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      )
      : status === message.Extension_Erf_Under_SE ? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      )
      : status === message.Extension_Erf_Pay_Collected ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ): status === message.pcCallClosed ? (
        <span className="bg-table-status bg-table-danger-status">
          {status}
        </span>
      ): status === message.pcCallPartial ? (
        <span className="bg-table-status bg-table-info-status">
          {status}
        </span>
      ):status === message.pcCallFollowUp ? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      ): status === message.pcCallIntransist ? (
        <span className="bg-table-status bg-table-info-status">
          {status}
        </span>
      ): status === message.PartialEarlyClosure? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      ): status === message.EarlyClosure? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      ): status === message.AssignServiceProvider? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      ): status === message.Erf_UnderServiceExecutive? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ): status === message.ServiceCancelled? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ): status === message.ServiceCompleted? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ): status === message.ServiceInProgress? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ): status === message.ServicePending? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ): status === message.Returning_Material_To_Store? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      ): status === message.Returning_To_Store? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ): status === message.Erf_Expired ? (
        <span className="bg-table-status bg-table-danger-status text-red-700">
          {status}
        </span>

      ): status === message.Erf_ExpiresToday ? (
        <span className="bg-table-status bg-orange-100 text-orange-700">
          {status}
        </span>

      ): status === message.Erf_1_day_left ? (
        <span className="bg-table-status bg-yellow-100 text-yellow-700">
          {status}
        </span>

      ): status === message.Erf_2_days_left ? (
        <span className="bg-table-status bg-blue-100 text-blue-700">
          {status}
        </span>

      ): status === message.Erf_3_days_left ? (
        <span className="bg-table-status bg-purple-100 text-purple-700">
          {status}
        </span>

      ): status === message.Erf_Valid ? (
        <span className="bg-table-status bg-green-100 text-green-700">
          {status}
        </span>

      ): status === message.RFQ_Submitted ? (
        <span className="bg-table-status bg-green-100 text-blue-700">
          {status}
        </span>
      ):status === message.Reverse_Auction ? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      ): status === message.Forward_Auction ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ): status === message.Ended ? (
        <span className="bg-table-status bg-table-danger-status">
          {message.Ended}
        </span>
      ): status === message.Pending_Artwork ? (
        <span className="bg-table-status bg-table-warning-status">
          {status}
        </span>
      ): status === message.Pending_Artwork_Approval || status === message.Under_Review ? (
        <span className="bg-table-status bg-table-progress-status">
          {status}
        </span>
      ): status === message.Approved_Ready_For_QAP ? (
        <span className="bg-table-status bg-table-success-status">
          {status}
        </span>
      ): status === message.In_QAP ? (
        <span className="bg-table-status bg-table-new-status">
          {status}
        </span>
      ): status === message.Artwork_Rejected ? (
        <span className="bg-table-status bg-table-danger-status">
          {status}
        </span>
      ):(
        status || "-"
      )}
    </>
  );
};

 
 